<template>
	<el-dialog
		:title="`${scene == 'add' ? '新增' : '修改'}`"
		width="550px"
		v-model="data.dialogTableVisible"
	>
		<el-form label-width="90px">
            <el-form-item label="充值金额">
                <el-input
                    type="number"
                    v-model="data.formLabelAlign.rechargeAmount"
                    placeholder="请输入充值金额"
                ></el-input>
            </el-form-item>
            <el-form-item label="赠送金额">
                <el-input
                    type="number"
                    v-model="data.formLabelAlign.giftAmount"
                    placeholder="请输入赠送金额"
                ></el-input>
            </el-form-item>
		</el-form>
		<footer class="tac" style="margin-top: 50px">
			<el-button @click="handleCancle">取消</el-button>
			<el-button type="primary" @click="handleSave">确定</el-button>
		</footer>
	</el-dialog>
</template>

<script>
import { defineComponent, inject, reactive } from "vue";
import {
    rechargeConfigUpdate,
	apiUserParkingLotList,
} from "@/api/requestApis.js";
import { isMobile } from "@/api/utils.js";
import { ElMessage } from "element-plus";
export default defineComponent({
	props: {
		scene: {
			type: String,
			default: "add",
		},
		currentData: {
			type: Object,
			default() {
				return {};
			},
		},
	},
	setup(props) {
		const userTypeInfo = inject("userTypeInfo");
		const handleUpdateTable = inject("handleUpdateTable");
		const data = reactive({
			cheChangName: "",
			dialogTableVisible: false,
			formLabelAlign: {
				name: "",
				parkingLotId: "",
				phone: "",
                deposit: "",
			},
		});

		const handleReset = () => {
			Object.keys(data.formLabelAlign).forEach((key) => {
				data.formLabelAlign[key] = "";
			});
		};

		const handleSetDefaultVal = () => {
			data.formLabelAlign.rechargeAmount = props.currentData.rechargeAmount;
			data.formLabelAlign.giftAmount = props.currentData.giftAmount;
		};

		const handleToggle = (val) => {
			if (val) {
				if (props.scene === "edit") {
					setTimeout(() => {
						handleSetDefaultVal();
					}, 10);
				}
			}
			data.dialogTableVisible = val;
		};
		const handleSave = async () => {
			if (props.scene === "edit") {
				await rechargeConfigUpdate({
					...data.formLabelAlign,
					userType: props.currentData.userType,
					id: props.currentData.id,
				});
			}
			handleToggle(false);
			handleReset();
			handleUpdateTable();
		};

		const handleCancle = () => {
			handleToggle(false);
			handleReset();
		};
		const querySearchAsync = async (val, cb) => {
			const res = await apiUserParkingLotList({
				name: val,
			});
			const list = res.map((item) => {
				return {
					value: item.name,
					...item,
				};
			});
			cb(list);
		};
		const handleSelect = (val) => {
			data.formLabelAlign.parkingLotId = val.id;
		};
		return {
			userTypeInfo,
			querySearchAsync,
			handleSelect,
			handleCancle,
			handleSave,
			handleToggle,
			data,
		};
	},
});
</script>

<style scoped>
</style>
